import React, { useEffect, useState } from "react";
import Header from "../../components/Header";
import "./style.scss";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import orderStore from "../../stores/order";
import { useIdleTimer } from "react-idle-timer";
import config from "../../config/default.json";
import { hideAlert, hideDialog } from "../../helpers/ComponentHelper";


const OrderIdlePage = () => {
    const [t] = useTranslation();
    const navigate = useNavigate();

    const [sec, setSec] = useState<number>(config.idleStatus.idlePage.timeout / 1000);

    useEffect(() => {
        hideAlert();
        hideDialog();
        setInterval(() => {
            setSec(Math.round(getRemainingTime() / 1000));
        }, 1000);
    }, []);

    const goBack = () => {
        navigate(-1);
    }

    const goToStart = async () => {
        await orderStore.cancelOrder();
        navigate("/");
    }

    const onIdle = () => {
        goToStart();
    }

    const { getRemainingTime } = useIdleTimer({
        onIdle,
        timeout: config.idleStatus.idlePage.timeout
    });

    return <div className="OrderIdlePage">
        <Header />
        <div className="container">
            <h2>{t('stillHere')}</h2>
            <div className="buttons">
                <div className="button" onClick={goBack}>{t("yesContinue")}</div>
                <div className="button" onClick={goToStart}>{t("startOver")}</div>
            </div>
            <div className="timer">
                <div>{t("autoCloseAfter")}:</div>
                <div>
                    <span className="value">{sec}</span> {t("sec")}
                </div>
            </div>
        </div>
    </div>
}

export default OrderIdlePage;